module.exports = __webpack_public_path__ + "img/cuffs_en_white.91a47e2d.png";